/**
 * Versandart einer Bestellung: Shopify (DPD-Etikett) oder eigene Zustellung.
 *
 * Eine Regel für Server (api/_lib/shopifyOrderPush.js) und Oberfläche —
 * bewusst ohne Imports, damit beide Seiten dieselbe Datei laden.
 *
 *   1. orders.versand_art ('shopify' | 'eigen') = Admin-Ausnahme, hat Vorrang
 *   2. sonst leads.shopify_versand (false = eigene Zustellung)
 *   3. fehlt beides (z. B. Migration noch nicht aus) → Shopify wie bisher
 */

export const VERSAND = Object.freeze({ SHOPIFY: 'shopify', EIGEN: 'eigen' });

/**
 * @param {{ versand_art?: string|null }} order
 * @param {{ shopify_versand?: boolean|null }|null} lead
 * @returns {'shopify'|'eigen'}
 */
export function resolveVersandArt(order, lead) {
  const ausnahme = order?.versand_art;
  if (ausnahme === VERSAND.SHOPIFY || ausnahme === VERSAND.EIGEN) return ausnahme;
  return lead?.shopify_versand === false ? VERSAND.EIGEN : VERSAND.SHOPIFY;
}

/**
 * Für Listen: Menge der Kontakt-IDs mit eigener Zustellung statt ganzer Kontakte.
 * @param {{ lead_id?: string|null, versand_art?: string|null }} order
 * @param {Set<string>} eigeneKundenIds
 */
export function istEigeneZustellung(order, eigeneKundenIds) {
  const lead = order?.lead_id && eigeneKundenIds?.has(order.lead_id) ? { shopify_versand: false } : null;
  return resolveVersandArt(order, lead) === VERSAND.EIGEN;
}
